// ============================================================
// FILE: src/api/axios.js
// PURPOSE: Single axios instance used by ALL api calls.
//          Automatically attaches JWT token to every request.
// ============================================================

import axios from 'axios';

const api = axios.create({
  baseURL: 'https://homecare-backend.weblinkltd.com/api',  // your Node.js backend
  headers: { 'Content-Type': 'application/json' },
});

// REQUEST interceptor — adds token before every request
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('ec_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// RESPONSE interceptor — if token expired, redirect to login
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 403 || error.response?.status === 401) {
      // Token expired or invalid — clear storage and redirect
      localStorage.removeItem('ec_token');
      localStorage.removeItem('ec_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;